export default {"src":"/_next/static/media/storage.d3118a61.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};